import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApacForm, ApacItem } from '@project/view-models';
import { ApiService } from '@core/http';
import { environment } from '@env';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SessionDetailsApacService {
  constructor(private apiService: ApiService) {}

  getApacFormsviaPatientId(patientId: string): Observable<ApacItem[]> {
    const url = `${environment.environmentVariables.apiCoreUrl}/Apac?PatientId=${patientId}&orderBy=created_at&direction=desc`;
    return this.apiService.get<ApacItem[]>(url);
  }

  getApacFormsviaRequisitionId(requisitionId: string): Observable<ApacItem[]> {
    const url = `${environment.environmentVariables.apiCoreUrl}/Apac?RequisitionId=${requisitionId}&orderBy=created_at&direction=desc`;
    return this.apiService.get<ApacItem[]>(url);
  }

  createApacForm(apacForm: ApacForm): Observable<void> {
    return this.apiService.post<void>(`${environment.environmentVariables.apiCoreUrl}/Apac`, apacForm);
  }

  downloadApac(id: string): Observable<string> {
    return this.apiService.get(`${environment.environmentVariables.apiCoreUrl}/Apac/${id}/Download`, {}, 'text').pipe(
      map((response: any) => {
        return response.toString();
      }),
    );
  }
}
